import { ChangeDetectionStrategy, Component, ElementRef, EventEmitter, Input, Output, ViewChild } from '@angular/core';

import { ProjectUser } from '../../../shared/models/project.model';

declare var jQuery: any;

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: 'app-transfer-ownership-confirmation-modal',
    templateUrl: './transfer-ownership-confirmation-modal.component.html',
    styleUrls: ['./transfer-ownership-confirmation-modal.component.scss', '../../scss/modal.scss'],
    standalone: false
})
export class TransferOwnershipConfirmationModalComponent {

  @ViewChild('transferOwnershipConfirmationModal') transferOwnershipConfirmationModalEl: ElementRef;

  @Input() user: ProjectUser;
  @Input() isLoading: boolean;

  @Output() confirm = new EventEmitter<ProjectUser>();
  @Output() decline = new EventEmitter();

  onConfirm() {
    this.confirm.emit(this.user);
  }

  onDecline() {
    this.decline.emit();
  }

  openModal() {
    jQuery(this.transferOwnershipConfirmationModalEl.nativeElement).modal('show');
  }

  closeModal() {
    (document.activeElement as HTMLElement)?.blur();
    jQuery(this.transferOwnershipConfirmationModalEl.nativeElement).modal('hide');
  }

  openModalWithUserSelected(projectUser: ProjectUser) {
    this.user = projectUser;
    this.openModal();
  }
}
